import { ReactNode } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import "./filterBadge.scss";

export const FilterBadge = (props: FilterBadgeProps) => {
  const iconPosition = props.iconPosition ?? "end";
  // Defaults to the remove icon; pass `icon={null}` for a badge without one.
  const icon =
    props.icon === undefined ? <CancelIcon fontSize="inherit" /> : props.icon;
  return (
    <span
      className={`badge rounded-pill filter-badge ${props.className ?? ""}`}
      role="button"
      tabIndex={0}
      title={props.title}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          props.onClick();
        }
      }}
    >
      {icon && iconPosition === "start" && (
        <span className="filter-badge__icon">{icon}</span>
      )}
      <span className="filter-badge__label">{props.label}</span>
      {icon && iconPosition === "end" && (
        <span className="filter-badge__icon">{icon}</span>
      )}
    </span>
  );
};

interface FilterBadgeProps {
  label: ReactNode;
  onClick: () => void;
  /** Defaults to the remove icon; `null` renders no icon. */
  icon?: ReactNode | null;
  iconPosition?: "start" | "end";
  title?: string;
  className?: string;
}
